import { MenuRolePermissionEnum } from './role-permissions';

export const PagePermissions = {
  All: [
    MenuRolePermissionEnum.View,
    MenuRolePermissionEnum.Create,
    MenuRolePermissionEnum.Delete,
    MenuRolePermissionEnum.Edit
  ],
  PageList: [
    MenuRolePermissionEnum.View,
    MenuRolePermissionEnum.Create,
    MenuRolePermissionEnum.Delete,
    MenuRolePermissionEnum.Edit
  ],
  Details: [
    MenuRolePermissionEnum.View,
    MenuRolePermissionEnum.Create,
    MenuRolePermissionEnum.Delete,
    MenuRolePermissionEnum.Edit
  ],
  Create: [
    MenuRolePermissionEnum.Create,
    MenuRolePermissionEnum.Edit,
    MenuRolePermissionEnum.Delete
  ],
  Update: [
    MenuRolePermissionEnum.Edit,
    MenuRolePermissionEnum.Delete
  ],
  Delete: [
    MenuRolePermissionEnum.Delete
  ],
  Print: [
    MenuRolePermissionEnum.View,
    MenuRolePermissionEnum.Create,
    MenuRolePermissionEnum.Delete,
    MenuRolePermissionEnum.Edit
  ]
};
